import { useLayoutEffect, useRef } from "react";
import { flushSync } from "react-dom";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetAnalyticsOnSectionChange } from "@store/appNavigation.actions";
import { resetDatePicker } from "@store/datePicker/datePicker.slice";

/**
 * Un seul endroit : à chaque changement de `pathname`, remet dates + analytics
 * puis remonte la page (`key`) pour que les `useEffect` ne voient pas l’ancien filtre.
 * Le ref évite un double reset en React StrictMode (même pathname).
 */
export function SectionOutlet() {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const lastResetPath = useRef(null);

    useLayoutEffect(() => {
        if (lastResetPath.current === pathname) {
            return;
        }
        lastResetPath.current = pathname;
        flushSync(() => {
            dispatch(resetDatePicker());
            dispatch(resetAnalyticsOnSectionChange());
        });
    }, [pathname, dispatch]);

    return <Outlet key={pathname} />;
}
